import { MbExpandableTextModule, MbProgressBarModule } from '@am/moebius';
import { AmSearchBoxModule } from '@am/search-box';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { BackgroundImageDirective, DeferLoadDirective } from '@shared/directives';
import { CurrencyPipe } from '@shared/pipes';
import { AlertContentComponent } from '../commons/alert-content/alert-content.component';
import { HeaderLandingComponent } from '../commons/header-landing/header-landing.component';
import { SearchWidgetComponent } from '../commons/search-widget/search-widget.component';
import { SearchBoxModalComponent } from '../commons/searchbox-modal/searchbox-modal.component';
import { SearchBoxSummaryComponent } from '../commons/searchbox-summary/searchbox-summary.component';
import { SearchBoxSkeletonComponent } from '../commons/searchbox-skeleton/searchbox-skeleton.component';

import { CheckPipe } from '@shared/pipes';
import { PaymentMethodModalComponent } from 'app/commons/payment-method-modal/payment-method-modal.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import {
  AppliedFiltersListComponent,
  BannerNowTwelveComponent,
  BenefitsBannerComponent,
  CardFilterComponent,
  CheckboxListComponent,
  ErrorNoResultsComponent,
  FewOfferAcceleratorComponent,
  FewOfferComponent,
  FiltersListComponent,
  FiltersListSkeletonComponent,
  HotelComponent,
  HotelPriceComponent,
  HotelsListComponent,
  HotelsListSkeletonComponent,
  InterlinkingComponent,
  OutstandingPromoComponent,
  PaginatorComponent,
  PriceByComponent,
  PricingExpandableComponent,
  PricingPopoverComponent,
  RecommendedHotelsComponent,
  SeoSearchComponent,
  SortingByComponent,
  SortingByMobileComponent,
  UserInactivityComponent,
  ViewMapComponent,
} from './../components';

import { BannerDollarTransferComponent } from './../components/banner-dollar-transfer/banner-dollar-transfer.component';
import { BannerBenefitDisneyComponent } from './../components/banner-benefit-disney/banner-benefit-disney.component';
import { BannerDollarComponent } from './../components/banner-dollar/banner-dollar.component';
import { HotelsMapInfoWindowComponent } from './../components/hotels-map/hotels-map-info-window/hotels-map-info-window.component';
import { HotelsMapComponent } from './../components/hotels-map/hotels-map.component';
import { hotelsIcons } from '@icons/index';
import { AmExpertsCompensationModule } from '@am/experts-compensation';
import { AmExpertsModalErrorModule } from '@am/experts-modal-error';
import { AmExpertsShareModule } from '@am/experts-share';
import { AmTripsAddProductModule } from '@am/trips-add-product';

import {
  MbAcceleratorModule,
  MbAdviceModule,
  MbAlertModule,
  MbBadgeModule,
  MbBreadcrumbsModule,
  MbButtonModule,
  MbCardModule,
  MbCarouselModule,
  MbCheckboxModule,
  MbChipsModule,
  MbDialogModule,
  MbExpandablePanelModule,
  MbFormFieldModule,
  MbIconModule,
  MbIconRegistry,
  MbIconTextModule,
  MbPaginatorModule,
  MbPopoverModule,
  MbRadioModule,
  MbRecommendedCardModule,
  MbReviewsRatingModule,
  MbSliderRangeModule,
  MbStarsRatingModule,
  MbSwitchModule,
  MbTooltipModule,
} from '@am/moebius';
import { FiltersMenuComponent } from 'app/components/filters-menu/filters-menu.component';

const COMPONENTS = [
  HotelsListComponent,
  HotelsListSkeletonComponent,
  HotelComponent,
  FiltersListComponent,
  CheckboxListComponent,
  CardFilterComponent,
  FiltersListSkeletonComponent,
  AppliedFiltersListComponent,
  OutstandingPromoComponent,
  PaginatorComponent,
  HotelPriceComponent,
  ErrorNoResultsComponent,
  PriceByComponent,
  SortingByComponent,
  UserInactivityComponent,
  SortingByMobileComponent,
  BenefitsBannerComponent,
  ViewMapComponent,
  BannerNowTwelveComponent,
  ViewMapComponent,
  FewOfferComponent,
  FewOfferAcceleratorComponent,
  RecommendedHotelsComponent,
  SeoSearchComponent,
  InterlinkingComponent,
  PricingExpandableComponent,
  PricingPopoverComponent,
  HotelsMapComponent,
  HotelsMapInfoWindowComponent,
  BannerDollarComponent,
  BannerBenefitDisneyComponent,
  BannerDollarTransferComponent,
  FiltersMenuComponent,
];

const MOEBIUSCOMPONENTS = [
  MbAcceleratorModule,
  MbCardModule,
  MbFormFieldModule,
  MbExpandablePanelModule,
  MbButtonModule,
  MbIconTextModule,
  MbIconModule,
  MbAdviceModule,
  MbAlertModule,
  MbTooltipModule,
  MbPopoverModule,
  MbStarsRatingModule,
  MbBadgeModule,
  MbReviewsRatingModule,
  MbCheckboxModule,
  MbSliderRangeModule,
  MbDialogModule,
  MbPaginatorModule,
  MbChipsModule,
  MbSwitchModule,
  MbBreadcrumbsModule,
  MbRadioModule,
  MbRecommendedCardModule,
  MbCarouselModule,
];

const EXPERTSCOMPONENTS = [
  AmExpertsShareModule,
  AmExpertsCompensationModule,
  AmExpertsModalErrorModule,
  AmTripsAddProductModule,
];

@NgModule({
  declarations: [
    CurrencyPipe,
    DeferLoadDirective,
    CheckPipe,
    AlertContentComponent,
    SearchBoxSummaryComponent,
    SearchBoxModalComponent,
    SearchBoxSkeletonComponent,
    HeaderLandingComponent,
    SearchWidgetComponent,
    BackgroundImageDirective,
    PaymentMethodModalComponent,
    ...COMPONENTS,
  ],
  exports: [
    ReactiveFormsModule,
    MbAlertModule,
    MbProgressBarModule,
    DeferLoadDirective,
    CurrencyPipe,
    CheckPipe,
    AlertContentComponent,
    SearchBoxSummaryComponent,
    SearchBoxModalComponent,
    SearchBoxSkeletonComponent,
    HeaderLandingComponent,
    SearchWidgetComponent,
    GoogleMapsModule,
    MbExpandableTextModule,
    BackgroundImageDirective,
    PaymentMethodModalComponent,
    ...COMPONENTS,
    ...MOEBIUSCOMPONENTS,
    ...EXPERTSCOMPONENTS,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MbAlertModule,
    MbIconTextModule,
    MbIconModule,
    MbDialogModule,
    AmSearchBoxModule,
    MbAlertModule,
    MbExpandableTextModule,
    GoogleMapsModule,
    ...MOEBIUSCOMPONENTS,
    ...EXPERTSCOMPONENTS,
  ],
  providers: [{ provide: 'BASE_URL_NTPM', useValue: '' }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  constructor(private mbIconRegistry: MbIconRegistry) {
    for (const icon of hotelsIcons) {
      this.mbIconRegistry.addSvgIconDefinition(icon);
    }
  }
}
